<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content m-0">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.editBasicInfoUser.title' | translate }}</h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body scroll mb-3">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-xs-12 mb-3">
                    <label class="form-label">{{ 'shared.editBasicInfoUser.nameLabel' | translate }}</label>
                    <input
                      type="text"
                      class="form-control"
                      maxlength="255"
                      formControlName="name"
                      [placeholder]="'shared.editBasicInfoUser.namePlaceholder' | translate"
                      required
                    />
                    <field-error-component
                      [field]="'name'"
                      [label]="'shared.editBasicInfoUser.nameFieldLabel' | translate"
                      [formGroup]="formGroup"
                    />
                  </div>
                  <div class="col-xs-12 col-xl-6 mb-3">
                    <label class="form-label">{{ 'shared.editBasicInfoUser.emailLabel' | translate }}</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="email"
                      [placeholder]="'shared.editBasicInfoUser.emailPlaceholder' | translate"
                      required
                    />
                    <field-error-component
                      [field]="'email'"
                      [label]="'shared.editBasicInfoUser.emailFieldLabel' | translate"
                      [formGroup]="formGroup"
                    />
                  </div>
                  <div class="col-xs-12 col-xl-6 mb-3">
                    <label class="form-label">{{ 'shared.editBasicInfoUser.phoneLabel' | translate }}</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="phone"
                      placeholder="(00) 00000-0000"
                      [mask]="'(00) 00000-0000'"
                      required
                    />
                    <field-error-component
                      [field]="'phone'"
                      [label]="'shared.editBasicInfoUser.phoneFieldLabel' | translate"
                      [formGroup]="formGroup"
                    />
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-6 mb-3">
                    <label class="form-label">{{ 'shared.editBasicInfoUser.tinLabel' | translate }}</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="tin"
                      placeholder="000.000.000-00"
                      [mask]="'000.000.000-00'"
                    />
                    <field-error-component
                      [field]="'tin'"
                      [label]="'shared.editBasicInfoUser.tinFieldLabel' | translate"
                      [formGroup]="formGroup"
                    />
                  </div>
                  <div
                    class="col-6 mb-3 trend-datepicker flex-column align-items-start"
                  >
                    <label class="form-label">{{ 'shared.editBasicInfoUser.birthDateLabel' | translate }}</label>
                    <div class="d-flex w-100">
                      <input
                        class="w-100"
                        [matDatepicker]="picker"
                        formControlName="birthDate"
                        placeholder="00/00/0000"
                        [disabled]="true"
                        (focus)="picker.open()"
                      />
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-12 mb-3">
                    <label class="form-label">{{ 'shared.editBasicInfoUser.languageLabel' | translate }}</label>
                    <select
                      class="form-select"
                      (change)="onLanguageChange($any($event.target).value)"
                    >
                      @for (locale of locales; track locale) {
                        <option [value]="locale" [selected]="locale === currentLanguage">
                          {{ localeLabels[locale] }}
                        </option>
                      }
                    </select>
                  </div>
                </div>

                <div class="row d-flex align-items-center justify-content-center">
                  <h4>{{ 'shared.editBasicInfoUser.profileImage' | translate }}</h4>
                  <div class="col-6" style="height: 128px;">
                    <div
                      class="upload-area"
                      [ngClass]="{ 'has-image': $safeNavigationMigration(user?.image) }"
                    >
                      @if (loadingSpinner$ | async) {
                        <loading-component class="loading" diameter="20" />
                      } @else {
                        @if (!user?.image) {
                          <div class="placeholder-content" (click)="addImage()">
                            <i
                              class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                            ></i>
                            <p class="text-primary">{{ 'shared.editBasicInfoUser.uploadPrompt' | translate }}</p>
                            <p class="text-muted">
                              {{ 'shared.editBasicInfoUser.uploadHint' | translate }}
                            </p>
                          </div>
                        }
                      }
                      <div
                        class="upload-area__image"
                        [ngStyle]="
                          (loadingSpinner$ | async)
                            ? { filter: 'blur(5px)' }
                            : {}
                        "
                      >
                        @if (user?.image) {
                          <figure class="figure-img">
                            <img
                              [src]="$safeNavigationMigration(user?.image)"
                              [alt]="('shared.editBasicInfoUser.imageAlt' | translate) + $safeNavigationMigration(user?.image)"
                              class="img-thumbnail rounded-circle"
                              width="120"
                              (click)="$event.stopPropagation()"
                            />
                          </figure>
                          @if(formGroup.get('name').value) {
                            <span class="font-16 fw-bold text-muted">{{ formGroup.get("name").value }}</span>
                          }
                          <i
                            class="mdi mdi-trash-can-outline text-danger cursor-pointer font-22"
                            (click)="removeMidia(); $event.stopPropagation()"
                            >
                          </i>
                        }
                      </div>

                      <input
                        #fileInputFile
                        type="file"
                        accept="image/jpeg, image/png"
                        (change)="onSelectImagem($event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="close()">
          {{ 'shared.editBasicInfoUser.cancelButton' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="save()"
          [disabled]="!formGroup.valid || !formGroup.dirty || loading"
        >
          {{ loading ? '     ' : ('shared.editBasicInfoUser.saveButton' | translate) }}
          @if(loading) {
            <mat-spinner
              [diameter]="25"
              [color]="'accent'"
              mode="indeterminate"
            />
          }
        </button>
      </div>
    </div>
  </div>
</div>
